import React from 'react';

export default function FormField({ label, required, error, hint, children, className = '', htmlFor }) {
  const fieldId = htmlFor || (label
    ? label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')
    : undefined);

  let processedChildren = children;
  if (fieldId) {
    try {
      const child = React.Children.only(children);
      if (child && !child.props.id) {
        processedChildren = React.cloneElement(child, { id: fieldId });
      }
    } catch {
      // multiple children — skip id injection
    }
  }

  return (
    <div className={`form-field ${className}`}>
      {label && (
        <label className="form-label" htmlFor={fieldId}>
          {label}
          {required && <span className="required">*</span>}
        </label>
      )}
      {processedChildren}
      {hint && !error && <span className="form-hint">{hint}</span>}
      {error && <span className="form-error">{error}</span>}
    </div>
  );
}
